<template>
  <div style="width: 100%">
    <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp
      v-bind:mesaj="text1"
      v-model="snackbar"
      v-bind:color="snackbarkColor"
    ></snackbarcomp>
<div v-if="isDomesticRT">
<br><br>
   <v-flex xs12 sm12 md12>
          <v-card width="100%" flat  class="pa-2">
            <v-layout row wrap align-center>
              <v-flex
                xs12
                sm12
                md9
                class="headline font-weight-bold grey--text text--darken-2"
              >
                <v-icon color="primary" class="mr-2">flight_takeoff</v-icon>
                {{ $t('Gidiş Uçuş Seçiniz') }}
              </v-flex>
              <v-flex xs12 sm12 md3 pt-2 d-flex justify-end>

               <v-btn color="info" @click="clearGidis()" v-if="domesticRTpickGidisItem!=null">Gidiş Uçuş Değiştir</v-btn>
              </v-flex>
             
            </v-layout>
          </v-card>
        </v-flex>
  <v-expansion-panel
      :value="openedPanel"
      class="pa-2"
      v-if="ticketList.length > 0"
    >
    
      <v-expansion-panel-content
        class="mt-2 elevation-3"
        v-for="(item, i) in getGidisler(ticketList)"
        :key="i"
        lazy
        readonly
        hide-actions
      >
        <template v-slot:header>
          
 <div>
           
            <v-layout
              row
              wrap
              v-for="(ticketInside, k) in item.FlightSegments"
              :key="k"
            >
             <v-flex xs12 sm12 md10 v-if="k>0">
                    <v-divider></v-divider>
                  </v-flex>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap>
                  <v-flex xs12 sm4 md2 class="my-auto">
                  <span class="provider-span" v-if="item.FlightSegments[0].Provider=='Turna'"> {{ $t('byturna')}} </span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='Amadeus'"> {{ $t('byamadeus')}}  </span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='BiletBank'"> {{ $t('bybiletbank')}}  </span>
                   
                  <v-img
                      :src="getImgUrl(item.FlightSegments[k].MarkettingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                   
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{ item.FlightSegments[k].DepartureTime }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[k].DepartureAirportName }} ({{
                            item.FlightSegments[k].DepartureAirportCode
                          }})   <span> {{ '/' }} {{ item.FlightSegments[k].MarkettingAirlineName }} </span></v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 sm4 md4 v-if="item.FlightSegments.length>1 && k==item.FlightSegments.length-1">
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[k].ArrivalTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[k].ArrivalAirportName }}
                          ({{
                            item.FlightSegments[k].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 sm4 md2 v-else>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[k].ArrivalTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[k].ArrivalAirportName }}
                          ({{
                            item.FlightSegments[k].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                   
                  <v-flex
                    xs12
                    sm2
                    md2
                    class="my-auto text-xs-center"
                    v-show="k == 0"
                  >
                  <!-- {{item.PricingInfo.Currency}} -->
                    <span class="headline" v-if="item.TotalFare>0">{{ Number(item.TotalFare).toFixed(2) }}  </span>
                    <span class="headline" v-else="item.SelectableFares.TotalFare>0">{{ Number(item.SelectableFares[0].TotalFare).toFixed(2)  }}   </span>
                  </v-flex>

                  <v-flex
                    xs12
                    sm2
                    md2
                    class="my-auto text-xs-center"
                    v-if="item.FlightSegments.length==1 || (k==item.FlightSegments.length-1)"
                  >
                    <v-btn
                     
                      color="success"
                      @click="openPanelGidis(i, 1, true)"
                      >SEC</v-btn
                    >
                  </v-flex>

                
                </v-layout>
              </v-flex>

          
            </v-layout>

           <!--burdan aldım-->
<v-layout row wrap>
    <v-flex xs12 sm12 md12>
                    <v-divider></v-divider>
                  </v-flex>
</v-layout>
            <v-layout row wrap>
            
              <v-flex xs12 sm4 md2>
                <v-chip color="green" text-color="white" small>{{
                  item.FlightSegments[0].CabinType
                }}</v-chip>
              </v-flex>

              <!-- AKTARMASIZ TEK YON UCUSLAR -->

              <v-flex xs12 sm4 md4 v-if="item.FlightSegments.length==1">
                <v-chip
                  color="blue"
                  text-color="white"
                  small
                  v-show="checkDirect(item.FlightSegments)"
                  >{{ $t("Direct") }}</v-chip
                >
              
              </v-flex>

              <!-- DIREKT GIDIS DONUS UCUSLARI -->

              <v-flex
                xs12
                sm4
                md4
                v-if="FlightType == 'RT' && item.FlightSegments.length == 2"
              >
                <v-chip
                  color="blue"
                  text-color="white"
                  v-show="checkDirect(item.FlightSegments)"
                  small
                >
                  {{ $t("Direct") }}
                </v-chip>
                  <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  {{ $t("Transfer-Flight") }} :
                  {{ calculateTimediff(item.FlightSegments, 2) }}</v-chip
                >
               
              </v-flex>

              <!-- AKTARMALI GIDIS DONUS UCUSLARI -->

              <v-flex
                xs12
                sm4
                md4
                v-if="FlightType == 'RT' && item.FlightSegments.length == 6"
              >
               
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  {{ $t("Transfer-Flight") }} :
                  {{ calculateTimediff(item.FlightSegments, 5) }}</v-chip
                >
              
              </v-flex>

              <!-- AKTARMALI GIDIS DONUS UCUSLARI -->

              <v-flex
                xs12
                sm4
                md4
                v-if="FlightType == 'RT' && item.FlightSegments.length == 4"
              >
              
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  {{ $t("Transfer-Flight") }} :
                  {{ calculateTimediff(item.FlightSegments, 1) }}</v-chip
                >
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  Dönüş aktarma:
                  {{ calculateTimediff(item.FlightSegments, 2) }}</v-chip
                >
              </v-flex>

              <v-flex xs12 sm4 md2>
                <v-chip color="indigo" text-color="white" small
                  >Branded Fares / {{ item.FlightSegments[0].BookingClass }} /
                  {{ item.FlightSegments[0].ResBookDesigQuantity }}
                </v-chip>
              </v-flex>
              <v-flex xs12 sm4 md2 class="my-auto text-xs-center">
                <v-btn
                  flat
                  small
                  class="my-0"
                  
                  @click="openPanelGidis(i, 2, false)"
                >
                  {{ $t("Show-Details") }}
                </v-btn>
              </v-flex>
              <v-flex xs12 sm4 md2 class="my-auto text-xs-center" v-if="item.SelectableFares==null || item.SelectableFares==[]">
                <v-btn
                  flat
                  small
                  class="my-0"
                 
                  @click="openPanelGidis(i, 3, false)"
                >
                  Diğer Fiyatlar
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
    
        
         
        </template>

          <v-container
          v-if="cardViewGidis || tableViewGidis || otherPricesGidis"
          fluid
          grid-list-xl
        >
          <v-layout row wrap>

           
            <v-flex v-if="cardViewGidis" >
            
              <v-layout v-if="item.IsSelectableFare==true">
<v-flex md4 v-for="itemflare in item.SelectableFares" :key="itemflare.FareCode">
<v-card class="card-container" :title="getFareTitle(itemflare)" height="100%">
       <v-card-title primary-title style="background-color: #92a2a8;">
        <v-layout justify-center >
            <h5 class="subheading mb-0"> {{ getFareTitle(itemflare) }}  </h5>
        </v-layout>
        </v-card-title>
        <v-card-text style="height:375px">
          <v-layout justify-center style="text-align:center;padding:6px;">
          {{ Number(itemflare.TotalFare).toFixed(2)  }} {{ itemflare.Currency }} 
          
        </v-layout>
        <v-divider></v-divider>
       
       <div v-if="item.FlightSegments[0].MarkettingAirline=='PC'">
        <br>
        <PegasusFareFeatures :fareName="itemflare.FareName" flightType="domestic" />
       </div>
       <div v-else-if="item.FlightSegments[0].MarkettingAirline=='TK'">
        <br>
        <THYFareFeatures :fareName="itemflare.FareName" flightType="domestic" />
       </div>
       <div v-else-if="item.FlightSegments[0].MarkettingAirline=='VF' || item.FlightSegments[0].MarkettingAirline=='IZ'">
        <br>
        <AjetFareFeatures :fareName="itemflare.FareName" flightType="domestic" />
       </div>
       <div v-else-if="itemflare.Penalties!='undefined' && itemflare.Penalties!=null">
         <v-flex md12>
          
          <v-layout justify-center style="text-align:center;padding:6px;" v-if='itemflare.CarryOnBaggageAllowance!=null'>
          {{  itemflare.CarryOnBaggageAllowance.Pieces }} Parça   {{  itemflare.CarryOnBaggageAllowance.Kilos }} kg Kabin Bagaj Hakkı 
        </v-layout>
       </v-flex>
      
      
        <v-flex md12>
          <v-divider></v-divider>
          <v-layout justify-center style="text-align:center;padding:6px;">
         {{  itemflare.CheckedBaggageAllowance.Pieces }} Parça   {{  itemflare.CheckedBaggageAllowance.Kilos }} kg Bagaj Hakkı  
        </v-layout>
       </v-flex>
  <v-flex md12  v-for="penalties in itemflare.Penalties.ChangePenalties">
        
          <v-layout justify-center style="text-align:center;padding:6px;" v-if="penalties.TimeToDeparture!=null" >
           
        
             <span v-if="penalties.TimeToDeparture.TimePeriodCondition=='LESS'">  Uçuş'a {{ penalties.TimeToDeparture.TimeAmount }} Saat veya Daha Az Zaman Var ise <span v-if="penalties.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  penalties.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="penalties.IsChangeable"> Değişiklik Yapılabilir</span><span v-else> Değişiklik Yapılamaz</span> </span><span v-else>  Uçuş'a {{ penalties.TimeToDeparture.TimeAmount }} Saat veya Daha Fazla Zaman Var ise <span v-if="penalties.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  penalties.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="penalties.IsChangeable"> Değişiklik Yapılabilir</span><span v-else> Değişiklik Yapılamaz</span></span>
        </v-layout>
        <v-layout justify-center style="text-align:center;padding:6px;" v-if="penalties.TimeToDeparture==null && penalties.Penalty!=null" >
           <span >{{ penalties.Penalty }}</span>
      </v-layout>
       </v-flex>
        <v-flex md12 v-if="itemflare.Penalties!='undefined' && itemflare.Penalties!='null'" v-for="cancellation in itemflare.Penalties.CancellationPenalties">
         
          <v-layout justify-center style="text-align:center;padding:6px;" v-if="cancellation.TimeToDeparture!=null" >
            <span v-if="cancellation.TimeToDeparture.TimePeriodCondition=='LESS'">  Uçuş'a {{ cancellation.TimeToDeparture.TimeAmount }} Saat veya Daha Az Zaman Var ise <span v-if="cancellation.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  cancellation.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="cancellation.IsRefundable"> İptal Edilebilir</span><span v-else> İptal Edilemez</span> </span><span v-else>  Uçuş'a {{ cancellation.TimeToDeparture.TimeAmount }} Saat veya Daha Fazla Zaman Var ise <span v-if="cancellation.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  cancellation.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="cancellation.IsRefundable"> İptal Edilebilir</span><span v-else> İptal Edilemez</span></span>
        </v-layout>
        <v-layout justify-center style="text-align:center;padding:6px;" v-if="cancellation.TimeToDeparture==null && cancellation.Penalty!=null" >
           <span >{{ cancellation.Penalty }}</span>
      </v-layout>
        </v-flex>
          <v-flex md12>
          
        
       </v-flex>
       </div><div v-else></div>
      
        </v-card-text>
      <v-card-actions >
        <v-divider></v-divider>
        <v-btn :id="itemflare.FareCode" color="success"  @click="selectDomesticRTGidisFare(itemflare.FareCode,item)">Seç<v-icon right dark v-if="domesticRTselectedGidisFareCode === itemflare.FareCode ">check</v-icon></v-btn>
      </v-card-actions>
       
       


</v-card>
</v-flex>

</v-layout>

  <v-layout v-if="item.IsSelectableFare==false">
          <v-flex md-12>
     <div class="d-flex justify-end mb-6 text-lg-right">
      
      <v-flex md6 sm6>
          <span class="headline mt-2">Tutar :</span>
        <span class="headline mt-2">{{ Number(item.TotalFare).toFixed(2) }}</span>
 <v-divider></v-divider>
          
      </v-flex>
      <v-flex md1>
  <v-btn
      color="blue-grey"
      class="white--text"
      @click="selectFare('',item)"
    >
      {{$t('Continue')}}
      <v-icon right dark>check</v-icon>
    </v-btn>
      </v-flex>
  
         
     </div>
          </v-flex>
        

          
        </v-layout>
       
      
       
     

            
            </v-flex>
          </v-layout>
          <v-layout align-start justify-space-between row fill-height>
            <v-flex xs12 sm12 md12 sm4 md4 v-if="tableViewGidis">
            
              <v-data-table
                :headers="headersSummary"
                :items="item.FlightSegments"
                class="elevation-1 mb-3"
                hide-actions
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item.OperatingAirline }} {{ '-' }} <span v-if="props.item.DirectionInd==0"> Gidiş </span> <span v-if="props.item.DirectionInd==1"> Dönüş </span>
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.FlightNumber }} -
                    {{ props.item.DepartureAirportCode }} -
                    {{ props.item.ArrivalAirportCode }}
                  </td>
                  <td class="text-xs-left">
                    {{ formatDate(props.item.DepartureDate) }} -
                    {{ props.item.DepartureTime }}
                  </td>
                  <td class="text-xs-left">
                    {{ formatDate(props.item.ArrivalDate) }} -
                    {{ props.item.ArrivalTime }}
                  </td>
                  <td class="text-xs-left">{{ props.item.EquipmentType }}</td>
                  <td class="text-xs-left">
                    {{ props.item.CabinType }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.ResBookDesigQuantity }}
                  </td>
                </template>
              </v-data-table>

<div v-if="1==0">
  <v-data-table 
                :headers="headers"
                class="elevation-1"
                :items="item.SelectableFares"
                hide-actions
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item.PassengerTypeCode }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.BaseFare }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.TotalTax }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.ServiceFee }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.PassengerTypeQuantity }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.BaggageAllowance }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.TotalFare }}
                  </td>
                </template>

                <template v-slot:footer>
                  <td>
                    <strong> {{ $t("Totals") }} </strong>
                  </td>
                  <td>
                    <strong>{{ calculateFooter(1, i) }}</strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(2, i) }} </strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(3, i) }} </strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(4, i) }} </strong>
                  </td>
                  <td>
                    <strong></strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(5, i) }} </strong>
                  </td>
                </template>
              </v-data-table>
</div>
             


            </v-flex>
          </v-layout>
          
          <v-layout row wrap justify-end>
            <v-flex v-if="otherPricesGidis" xs12 sm12 md12 px-5>
              
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm4
                  md3
                  v-for="(itemPrices, indexPrices) in otherPricesList"
                  :key="indexPrices"
                >
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-for="(
                      itemPricesInfo, indexPricesInfo
                    ) in itemPrices.FlightSegments"
                    :key="indexPricesInfo"
                  >
                    <v-card>
                      <v-card-title>
                        <v-layout
                          row
                          wrap
                          align-center
                          justify-center
                          class="font-weight-medium title pa-2"
                        >
                         <div v-if="itemPricesInfo!=null">
                          {{ itemPricesInfo.CabinType }} -
                          {{ itemPrices.TotalFare }}
                          {{ itemPrices.Currency }}
                        </div><div v-else>
  {{  item.FlightSegments[0].CabinType }} -
                          {{ item.TotalFare }}
                          {{ item.SelectableFares[0].Currency }}
                        </div>

                        </v-layout>
                      </v-card-title>
                      <v-divider></v-divider>

                      <v-card-text>
                        <v-layout row wrap align-center justify-center>
                          <v-flex
                            xs12
                            sm12
                            md12
                            v-for="(
                              itemFareBreakdown, indexFareBreakdown
                            ) in itemPricesInfo.PricingInfo.FareBreakdowns"
                            :key="indexFareBreakdown"
                          >
                            <v-flex
                              xs12
                              sm12
                              md12
                              v-for="(
                                itemAmenities, indexAmenities
                              ) in itemFareBreakdown.Amenities"
                              :key="indexAmenities"
                            >
                              <v-layout
                                row
                                wrap
                                align-center
                                justify-center
                                class="font-weight-medium body-1 pa-2"
                              >
                                {{ itemAmenities.Description }}
                              </v-layout>
                            </v-flex>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <!-- <v-btn
                              block
                              color="primary"
                              @click="setUpSellTicket(itemPrices)"
                              dark
                              >Seç</v-btn
                            > -->
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-expansion-panel-content>
  </v-expansion-panel>

<v-flex xs12 sm12 md12>
          <v-card width="100%" flat  class="pa-2">
            <v-layout row wrap align-center>
              <v-flex
                xs12
                sm12
                md9
                class="headline font-weight-bold grey--text text--darken-2"
              >
                <v-icon color="primary" class="mr-2">flight_land</v-icon>
                {{ $t('Dönüş Uçuş Seçiniz') }}
              </v-flex>
              <v-flex xs12 sm12 md3 pt-2 d-flex justify-end>

               <v-btn color="info" @click="clearDonus()" v-if="domesticRTpickDonusItem!=null">Dönüş Uçuş Değiştir</v-btn>
              </v-flex>
             
            </v-layout>
          </v-card>
        </v-flex>

  <v-expansion-panel
      :value="openedPanel"
      class="pa-2"
      v-if="ticketList.length > 0"
    >
    
      <v-expansion-panel-content
        class="mt-2 elevation-3"
        v-for="(item, i) in getDonusler(ticketList)"
        :key="i"
        lazy
        readonly
        hide-actions
      >
        <template v-slot:header>
          
 <div>
              <v-layout
              row
              wrap
              v-for="(ticketInside, k) in item.FlightSegments"
              :key="k"
            >
             <v-flex xs12 sm12 md10 v-if="k>0">
                    <v-divider></v-divider>
                  </v-flex>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap>
                  <v-flex xs12 sm4 md2 class="my-auto">
                  <span class="provider-span" v-if="item.FlightSegments[0].Provider=='Turna'"> {{ $t('byturna')}} </span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='Amadeus'"> {{ $t('byamadeus')}}  </span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='BiletBank'"> {{ $t('bybiletbank')}}  </span>
                   
                  <v-img
                      :src="getImgUrl(item.FlightSegments[k].MarkettingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                   
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{ item.FlightSegments[k].DepartureTime }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[k].DepartureAirportName }} ({{
                            item.FlightSegments[k].DepartureAirportCode
                          }})   <span> {{ '/' }} {{ item.FlightSegments[k].MarkettingAirlineName }} </span></v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 sm4 md4 v-if="item.FlightSegments.length>1 && k==item.FlightSegments.length-1">
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[k].ArrivalTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[k].ArrivalAirportName }}
                          ({{
                            item.FlightSegments[k].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 sm4 md2 v-else>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[k].ArrivalTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[k].ArrivalAirportName }}
                          ({{
                            item.FlightSegments[k].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                   
                  <v-flex
                    xs12
                    sm2
                    md2
                    class="my-auto text-xs-center"
                    v-show="k == 0"
                  >
                 
                    <span class="headline" v-if="item.TotalFare>0">{{ Number(item.TotalFare).toFixed(2) }}  </span>
                    <span class="headline" v-else="item.SelectableFares.TotalFare>0">{{ Number(item.SelectableFares[0].TotalFare).toFixed(2)  }}   </span>
                  </v-flex>

                  <v-flex
                    xs12
                    sm2
                    md2
                    class="my-auto text-xs-center"
                    v-if="item.FlightSegments.length==1 || (k==item.FlightSegments.length-1)"
                  >
                    <v-btn
                     
                      color="success"
                      @click="openPanel(i, 1, true)"
                      >SEC</v-btn
                    >
                  </v-flex>

                
                </v-layout>
              </v-flex>

          
            </v-layout>
          

            <v-layout row wrap>
              <v-flex xs12 sm4 md2>
                <v-chip color="green" text-color="white" small>{{
                  item.FlightSegments[0].CabinType
                }}</v-chip>
              </v-flex>

             

            

             

              <v-flex
                xs12
                sm4
                md4
               
              >
                <v-chip
                  color="blue"
                  text-color="white"
                  small
                  v-show="checkDirect(item.FlightSegments)"
                >
                  {{ $t("Direct") }}
                </v-chip>
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                   Dönüş aktarma:
                  {{ calculateTimediff(item.FlightSegments, 1) }}</v-chip
                >
              </v-flex>

             

              

              <v-flex xs12 sm4 md2>
                <v-chip color="indigo" text-color="white" small
                  >Branded Fares / {{ item.FlightSegments[0].BookingClass }} /
                  {{ item.FlightSegments[0].ResBookDesigQuantity }}
                </v-chip>
              </v-flex>
              <v-flex xs12 sm4 md2 class="my-auto text-xs-center">
                <v-btn
                  flat
                  small
                  class="my-0"
                  
                  @click="openPanel(i, 2, false)"
                >
                  {{ $t("Show-Details") }}
                </v-btn>
              </v-flex>
              <v-flex xs12 sm4 md2 class="my-auto text-xs-center">
                <v-btn
                  flat
                  small
                  class="my-0"
                 
                  @click="openPanel(i, 3, false)"
                >
                  Diğer Fiyatlar
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
    
        
         
        </template>

        <v-container
          v-if="cardView || tableView || otherPrices"
          fluid
          grid-list-xl
        >
          <v-layout row wrap>

           
            <v-flex v-if="cardView" >
            
              <v-layout v-if="item.IsSelectableFare==true">
<v-flex md4 v-for="itemflare in item.SelectableFares" :key="itemflare.FareCode">
<v-card class="card-container" :title="getFareTitle(itemflare)" height="100%">
       <v-card-title primary-title style="background-color: #92a2a8;">
        <v-layout justify-center >
            <h5 class="subheading mb-0"> {{ getFareTitle(itemflare) }}  </h5>
        </v-layout>
        </v-card-title>
        <v-card-text style="height:375px">
          <v-layout justify-center style="text-align:center;padding:6px;">
          {{ Number(itemflare.TotalFare).toFixed(2)  }} {{ itemflare.Currency }} 
          
        </v-layout>
        <!-- <v-divider></v-divider> -->
       
       <div v-if="item.FlightSegments[0].MarkettingAirline=='PC'">
        <br>
        <PegasusFareFeatures :fareName="itemflare.FareName" flightType="domestic" />
       </div>
       <div v-else-if="item.FlightSegments[0].MarkettingAirline=='TK'">
        <br>
        <THYFareFeatures :fareName="itemflare.FareName" flightType="domestic" />
       </div>
       <div v-else-if="item.FlightSegments[0].MarkettingAirline=='VF' || item.FlightSegments[0].MarkettingAirline=='IZ'">
        <br>
        <AjetFareFeatures :fareName="itemflare.FareName" flightType="domestic" />
       </div>
       <div v-else-if="itemflare.Penalties!='undefined' && itemflare.Penalties!=null">
         <v-flex md12>
          
          <v-layout justify-center style="text-align:center;padding:6px;" v-if='itemflare.CarryOnBaggageAllowance!=null'>
          {{  itemflare.CarryOnBaggageAllowance.Pieces }} Parça   {{  itemflare.CarryOnBaggageAllowance.Kilos }} kg Kabin Bagaj Hakkı 
        </v-layout>
       </v-flex>
      
      
        <v-flex md12>
          <!-- <v-divider></v-divider> -->
          <v-layout justify-center style="text-align:center;padding:6px;">
         {{  itemflare.CheckedBaggageAllowance.Pieces }} Parça   {{  itemflare.CheckedBaggageAllowance.Kilos }} kg Bagaj Hakkı  
        </v-layout>
       </v-flex>
  <v-flex md12  v-for="penalties in itemflare.Penalties.ChangePenalties">
        
          <v-layout justify-center style="text-align:center;padding:6px;" v-if="penalties.TimeToDeparture!=null" >
           
        
             <span v-if="penalties.TimeToDeparture.TimePeriodCondition=='LESS'">  Uçuş'a {{ penalties.TimeToDeparture.TimeAmount }} Saat veya Daha Az Zaman Var ise <span v-if="penalties.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  penalties.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="penalties.IsChangeable"> Değişiklik Yapılabilir</span><span v-else> Değişiklik Yapılamaz</span> </span><span v-else>  Uçuş'a {{ penalties.TimeToDeparture.TimeAmount }} Saat veya Daha Fazla Zaman Var ise <span v-if="penalties.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  penalties.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="penalties.IsChangeable"> Değişiklik Yapılabilir</span><span v-else> Değişiklik Yapılamaz</span></span>
        </v-layout>
        <v-layout justify-center style="text-align:center;padding:6px;" v-if="penalties.TimeToDeparture==null && penalties.Penalty!=null" >
           <span >{{ penalties.Penalty }}</span>
      </v-layout>
       </v-flex>
        <v-flex md12 v-if="itemflare.Penalties!='undefined' && itemflare.Penalties!='null'" v-for="cancellation in itemflare.Penalties.CancellationPenalties">
         
          <v-layout justify-center style="text-align:center;padding:6px;" v-if="cancellation.TimeToDeparture!=null" >
            <span v-if="cancellation.TimeToDeparture.TimePeriodCondition=='LESS'">  Uçuş'a {{ cancellation.TimeToDeparture.TimeAmount }} Saat veya Daha Az Zaman Var ise <span v-if="cancellation.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  cancellation.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="cancellation.IsRefundable"> İptal Edilebilir</span><span v-else> İptal Edilemez</span> </span><span v-else>  Uçuş'a {{ cancellation.TimeToDeparture.TimeAmount }} Saat veya Daha Fazla Zaman Var ise <span v-if="cancellation.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  cancellation.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="cancellation.IsRefundable"> İptal Edilebilir</span><span v-else> İptal Edilemez</span></span>
        </v-layout>
        <v-layout justify-center style="text-align:center;padding:6px;" v-if="cancellation.TimeToDeparture==null && cancellation.Penalty!=null" >
           <span >{{ cancellation.Penalty }}</span>
      </v-layout>
        </v-flex>
          <v-flex md12>
          
        
       </v-flex>
       </div><div v-else></div>
      
        </v-card-text>
      <v-card-actions >
      
        <v-btn :id="itemflare.FareCode" color="success"  @click="selectDomesticRTDonusFare(itemflare.FareCode,item)">Seç<v-icon right dark v-if="domesticRTselectedDonusFareCode === itemflare.FareCode ">check</v-icon></v-btn>
      </v-card-actions>
       
       


</v-card>
</v-flex>

</v-layout>

       
         <v-layout v-if="item.IsSelectableFare==false">
          <v-flex md-12>
     <div class="d-flex justify-end mb-6 text-lg-right">
      
      <v-flex md6 sm6>
          <span class="headline mt-2">Tutar :</span>
        <span class="headline mt-2">{{ Number(item.TotalFare).toFixed(2) }}</span>
 <v-divider></v-divider>
          
      </v-flex>
      <v-flex md1>
  <v-btn
      color="blue-grey"
      class="white--text"
      @click="selectFare('',item)"
    >
      {{$t('Continue')}}
      <v-icon right dark>check</v-icon>
    </v-btn>
      </v-flex>
  
         
     </div>
          </v-flex>
        

          
        </v-layout>
      
       
     

             
            </v-flex>
          </v-layout>
          <v-layout align-start justify-space-between row fill-height>
            
            <v-flex xs12 sm12 md12 sm4 md4 v-if="tableView">
            
              <v-data-table
                :headers="headersSummary"
                :items="item.FlightSegments"
                class="elevation-1 mb-3"
                hide-actions
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item.OperatingAirline }} {{ '-' }} <span v-if="props.item.DirectionInd==0"> Gidiş </span> <span v-if="props.item.DirectionInd==1"> Dönüş </span>
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.FlightNumber }} -
                    {{ props.item.DepartureAirportCode }} -
                    {{ props.item.ArrivalAirportCode }}
                  </td>
                  <td class="text-xs-left">
                    {{ formatDate(props.item.DepartureDate) }} -
                    {{ props.item.DepartureTime }}
                  </td>
                  <td class="text-xs-left">
                    {{ formatDate(props.item.ArrivalDate) }} -
                    {{ props.item.ArrivalTime }}
                  </td>
                  <td class="text-xs-left">{{ props.item.EquipmentType }}</td>
                  <td class="text-xs-left">
                    {{ props.item.CabinType }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.ResBookDesigQuantity }}
                  </td>
                </template>
              </v-data-table>

<div v-if="1==0">
  <v-data-table 
                :headers="headers"
                class="elevation-1"
                :items="item.SelectableFares"
                hide-actions
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item.PassengerTypeCode }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.BaseFare }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.TotalTax }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.ServiceFee }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.PassengerTypeQuantity }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.BaggageAllowance }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.TotalFare }}
                  </td>
                </template>

                <template v-slot:footer>
                  <td>
                    <strong> {{ $t("Totals") }} </strong>
                  </td>
                  <td>
                    <strong>{{ calculateFooter(1, i) }}</strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(2, i) }} </strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(3, i) }} </strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(4, i) }} </strong>
                  </td>
                  <td>
                    <strong></strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(5, i) }} </strong>
                  </td>
                </template>
              </v-data-table>
</div>
             


            </v-flex>
          </v-layout>
          <v-layout row wrap justify-end>
           
            <v-flex v-if="otherPrices" xs12 sm12 md12 px-5>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm4
                  md3
                  v-for="(itemPrices, indexPrices) in otherPricesList"
                  :key="indexPrices"
                >
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-for="(
                      itemPricesInfo, indexPricesInfo
                    ) in itemPrices.FlightSegments"
                    :key="indexPricesInfo"
                  >
                    <v-card>
                      <v-card-title>
                        <v-layout
                          row
                          wrap
                          align-center
                          justify-center
                          class="font-weight-medium title pa-2"
                        >
                       
                          <div v-if="itemPricesInfo!=null">
                          {{ itemPricesInfo.CabinType }} -
                          {{ itemPrices.TotalFare }}
                          {{ itemPrices.Currency }}
                        </div><div v-else>
  {{  item.FlightSegments[0].CabinType }} -
                          {{ item.TotalFare }}
                          {{ item.SelectableFares[0].Currency }}
                        </div>

                        </v-layout>
                      </v-card-title>

                      <v-card-text>
                        <v-layout row wrap align-center justify-center>
                          <v-flex
                            xs12
                            sm12
                            md12
                            v-for="(
                              itemFareBreakdown, indexFareBreakdown
                            ) in itemPricesInfo.PricingInfo.FareBreakdowns"
                            :key="indexFareBreakdown"
                          >
                            <v-flex
                              xs12
                              sm12
                              md12
                              v-for="(
                                itemAmenities, indexAmenities
                              ) in itemFareBreakdown.Amenities"
                              :key="indexAmenities"
                            >
                              <v-layout
                                row
                                wrap
                                align-center
                                justify-center
                                class="font-weight-medium body-1 pa-2"
                              >
                                {{ itemAmenities.Description }}
                              </v-layout>
                            </v-flex>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-btn
                              block
                              color="primary"
                              @click="setUpSellTicket(itemPrices)"
                              dark
                              >Seç</v-btn
                            >
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-expansion-panel-content>
  </v-expansion-panel>
</div>
    <div v-else>
      <v-expansion-panel
      :value="openedPanel"
      class="pa-2"
      v-if="ticketList.length > 0"
    >
      <v-expansion-panel-content
        class="mt-2 elevation-3"
        v-for="(item, i) in ticketList"
        :key="i"
        lazy
        readonly
        hide-actions
      >
        <template v-slot:header>
          <div>
            <!-- AKTARMALI GIDIS DONUS UCUSLARI 6 KAYIT -->
            <v-layout
              row
              wrap
              v-if="item.FlightSegments.length == 6"
              v-for="(ticketInside, k) in item.FlightSegments"
              :key="k"
            >
              <v-flex xs12 sm12 md12>
                <v-layout row wrap v-if="k == 0 || k == 4">
                  <v-flex xs12 sm4 md2 class="my-auto">
                  <span class="provider-span" v-if="item.FlightSegments[0].Provider=='Turna'"> {{ $t('byturna')}} </span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='Amadeus'"> {{ $t('byamadeus')}}  </span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='BiletBank'"> {{ $t('bybiletbank')}}   </span>
                   
                  <v-img
                      :src="getImgUrl(item.FlightSegments[k].MarkettingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                   
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{ item.FlightSegments[k].DepartureTime }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[k].DepartureAirportName }} ({{
                            item.FlightSegments[k].DepartureAirportCode
                          }})   <span> {{ '/' }} {{ item.FlightSegments[k].MarkettingAirlineName }} </span></v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 sm4 md2 class="my-auto subheading"> </v-flex>
                  <v-flex xs12 sm4 md2>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[k + 1].ArrivalTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[k + 1].ArrivalAirportName }}
                          ({{
                            item.FlightSegments[k + 1].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                  <v-flex
                    xs12
                    sm2
                    md2
                    class="my-auto text-xs-center"
                    v-show="k == 0"
                  >
                  <!-- {{item.PricingInfo.Currency}} -->
                    <span class="headline" v-if="item.TotalFare>0">{{ Number(item.TotalFare).toFixed(2) }}  </span>
                    <span class="headline" v-else="item.SelectableFares.TotalFare>0">{{ Number(item.SelectableFares[0].TotalFare).toFixed(2)  }}   </span>
                  </v-flex>

                  <v-flex
                    xs12
                    sm2
                    md2
                    class="my-auto text-xs-center"
                    v-show="item.FlightSegments.length == k + 2"
                  >
                  
                     <v-btn 
                   
                    color="success"
                    @click="openPanel(i, 1, true)"
                    >SEC</v-btn
                  >
                    <!-- <v-btn v-else color="success" @click="openMailDialog()"
                      >SEC</v-btn  v-if="isActive"
                    > -->
                  </v-flex>

                  <v-flex xs12 sm12 md10>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12 v-if="k == 4">
                <v-divider></v-divider>
              </v-flex>
            </v-layout>

            <!-- AKTARMALI GIDIS DONUS UCUSLARI -->
            <v-layout
              row
              wrap
              v-if="item.FlightSegments.length == 4"
              v-for="(ticketInside, k) in item.FlightSegments"
              :key="k"
            >
           
              <v-layout row wrap v-if="k == 0 || k==2">
                <v-flex xs12 sm4 md2 class="my-auto">
                  <span class="provider-span" v-if="item.FlightSegments[0].Provider=='Turna'"> {{ $t('byturna')}}</span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='Amadeus'"> {{ $t('byamadeus')}}</span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='BiletBank'"> {{ $t('bybiletbank')}}</span> 
                 
                  <v-img
                    :src="getImgUrl(item.FlightSegments[k].MarkettingAirline)"
                    alt="K"
                    height="35px"
                    width="85px"
                    contain
                  >
                  </v-img>
                    
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title
                        >{{ item.FlightSegments[k].DepartureTime }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >
                         <span >
                           {{ item.FlightSegments[k].DepartureAirportName }} ({{
                          item.FlightSegments[k].DepartureAirportCode
                        }}) </span>
                          <!-- <span v-if="k==2">
                           {{ item.FlightSegments[k+1].ArrivalAirportName }} ({{
                          item.FlightSegments[k+1].ArrivalAirportCode
                        }}) </span> -->
                        <span> {{ '/' }} {{ item.FlightSegments[k].MarkettingAirlineName }} </span>
                        </v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>
                <v-flex xs12 sm4 md1 class="my-auto subheading"> </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{
                        item.FlightSegments[k+1].ArrivalTime
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>

  <span >
                           {{ item.FlightSegments[k+1].ArrivalAirportName }} ({{
                          item.FlightSegments[k+1].ArrivalAirportCode
                        }}) </span>
                         <!-- <span v-if="k==2">
                           {{ item.FlightSegments[k].DepartureAirportName }} ({{
                          item.FlightSegments[k].DepartureAirportCode
                        }}) </span> -->

                       
                       
                        </v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  class="my-auto text-xs-center"
                  v-show="k == 0"
                >
                <!-- {{item.PricingInfo.Currency}} -->
                <span class="headline" v-if="item.TotalFare>0">{{ Number(item.TotalFare).toFixed(2) }}  </span>
                    <span class="headline" v-else="item.SelectableFares.TotalFare>0">{{ Number(item.SelectableFares[0].TotalFare).toFixed(2)  }}   </span>
                 
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  class="my-auto text-xs-center"
                  v-show="item.FlightSegments.length == k + 2"
                >
                 <!-- <v-btn v-if="item.SelectableFares==null || item.SelectableFares==[]"
                   
                    color="success"
                    @click="openPanel(i, 3, true)"
                    >SEC13</v-btn
                  > -->
                     <v-btn 
                   
                    color="success"
                    @click="openPanel(i, 1, true)"
                    >SEC</v-btn
                  >
                  <!-- <v-btn v-else color="success" @click="openMailDialog()"
                    >SEC</v-btn
                  > -->
                </v-flex>

                <v-flex xs12 sm12 md10>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>

              <v-flex xs12 sm12 md12 v-if="k == 2">
                <v-divider></v-divider>
              </v-flex>
            </v-layout>

            <!-- AKTARMASIZ GIDIS DONUS UCUSLARI  -->
            <v-layout
              row
              wrap
              v-if="item.FlightSegments.length == 2 && FlightType == 'RT'"
              v-for="(ticketInside, l) in item.FlightSegments"
              :key="l"
            >
              <v-layout row wrap xs12 sm12 md12>
                <v-flex xs12 sm4 md2 class="my-auto">
                  <span class="provider-span" v-if="item.FlightSegments[0].Provider=='Turna'"> {{ $t('byturna')}}</span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='Amadeus'"> {{ $t('byamadeus')}}</span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='BiletBank'"> {{ $t('bybiletbank')}}</span>
                   
                  <v-img
                    :src="getImgUrl(item.FlightSegments[l].MarkettingAirline)"
                    alt="K"
                    height="35px"
                    width="85px"
                    contain
                  >
                  </v-img>
                 
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <span >{{ item.FlightSegments[l].DepartureTime }}  </span>
                          
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                       <span >{{ item.FlightSegments[l].DepartureAirportName }} ({{
                          item.FlightSegments[l].DepartureAirportCode
                        }}) </span>  <span> {{ '/' }} {{ item.FlightSegments[l].MarkettingAirlineName }} </span>
                        </v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>
                <v-flex xs12 sm4 md1 class="my-auto subheading"> </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title> <span>{{
                        item.FlightSegments[l].ArrivalTime
                      }} </span>
                      
                    </v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span > 
                        {{ item.FlightSegments[l].ArrivalAirportName }} ({{
                          item.FlightSegments[l].ArrivalAirportCode
                        }})</span>
                        
                        </v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  class="my-auto text-xs-center"
                  v-show="l == 0"
                >
                <!-- {{item.PricingInfo.Currency}} -->
                <span class="headline" v-if="item.TotalFare>0">{{ Number(item.TotalFare).toFixed(2) }}  </span>
                    <span class="headline" v-else="item.SelectableFares.TotalFare>0">{{ Number(item.SelectableFares[0].TotalFare).toFixed(2)  }}   </span>
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  class="my-auto text-xs-center"
                  v-show="item.FlightSegments.length == l + 1"
                >
                 
                     <v-btn 
                   
                    color="success"
                    @click="openPanel(i, 1, true)"
                    >SEC</v-btn
                  >
                  <!-- <v-btn v-else color="success" @click="openMailDialog()"
                    >SEC</v-btn
                  > -->
                </v-flex>

                <v-flex xs12 sm12 md10>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>

              <v-flex
                xs12
                sm12
                md12
                v-show="item.FlightSegments.length == l + 1"
              >
                <v-divider></v-divider>
              </v-flex>
            </v-layout>

            <!-- AKTARMALI TEK YON UCUSLAR -->
              <!-- v-for="(ticketInside, m) in item.FlightSegments"
              :key="m" -->
            <v-layout
              row
              wrap
              v-if="
                (item.FlightSegments.length == 2 && FlightType == 'OW') ||
                (item.FlightSegments.length == 3 && FlightType == 'OW')
              "
             
            >
              <v-layout row wrap xs12 sm12 md12>
                <v-flex xs12 sm4 md2 class="my-auto">
                  <span class="provider-span" v-if="item.FlightSegments[0].Provider=='Turna'"> {{ $t('byturna')}}</span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='Amadeus'"> {{ $t('byamadeus')}}</span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='BiletBank'"> {{ $t('bybiletbank')}}</span>
                  
                  <v-img
                    :src="getImgUrl(item.FlightSegments[0].MarkettingAirline)"
                    alt="K"
                    height="35px"
                    width="85px"
                    contain
                  >
                  </v-img>
                   
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title
                        >{{ item.FlightSegments[0].DepartureTime }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ item.FlightSegments[0].DepartureAirportName }} ({{
                          item.FlightSegments[0].DepartureAirportCode
                        }}) <span>{{ '/' }} {{ item.FlightSegments[0].MarkettingAirlineName }} </span></v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>
                <v-flex xs12 sm4 md2 class="my-auto subheading"> </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        item.FlightSegments[item.FlightSegments.length-1].ArrivalTime
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ item.FlightSegments[item.FlightSegments.length-1].ArrivalAirportName }} ({{
                          item.FlightSegments[item.FlightSegments.length-1].ArrivalAirportCode
                        }})</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>

                <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                  <!-- {{item.PricingInfo.Currency}} -->
                 <span class="headline" v-if="item.TotalFare>0">{{ Number(item.TotalFare).toFixed(2) }}  </span>
                    <span class="headline" v-else="item.SelectableFares.TotalFare>0">{{ Number(item.SelectableFares[0].TotalFare).toFixed(2)  }}   </span>
                </v-flex>

                <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                 
                     <v-btn 
                   
                    color="success"
                    @click="openPanel(i, 1, true)"
                    >SEC</v-btn
                  >
                 
                </v-flex>
              </v-layout>

              <v-flex xs12 sm12 md12>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>

            <!-- AKTARMASIZ TEK YON UCUSLAR -->
            <v-layout
              row
              wrap
               v-if="item.FlightSegments.length == 1"
             
            >
              <v-layout row wrap xs12 sm12 md12>
                <v-flex xs12 sm4 md2 class="my-auto">
                 <span class="provider-span" v-if="item.FlightSegments[0].Provider=='Turna'"> {{ $t('byturna')}}</span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='Amadeus'"> {{ $t('byamadeus')}}</span>
                  <span class="provider-span" v-else-if="item.FlightSegments[0].Provider=='BiletBank'"> {{ $t('bybiletbank')}}</span>
                  
                  <v-img
                    :src="getImgUrl(item.FlightSegments[0].MarkettingAirline)"
                    alt="K"
                    height="35px"
                    width="85px"
                    contain
                  >
                  </v-img>
                 
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title
                        >{{ item.FlightSegments[0].DepartureTime }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ item.FlightSegments[0].DepartureAirportName }} ({{
                          item.FlightSegments[0].DepartureAirportCode
                        }})    <span>{{ '/' }} {{ item.FlightSegments[0].MarkettingAirlineName }} </span></v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>
                <v-flex xs12 sm4 md2 class="my-auto subheading"> </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        item.FlightSegments[0].ArrivalTime
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ item.FlightSegments[0].ArrivalAirportName }} ({{
                          item.FlightSegments[0].ArrivalAirportCode
                        }})</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>

                <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                  <!-- {{item.PricingInfo.Currency}} -->
                 <span class="headline" v-if="item.TotalFare>0">{{ Number(item.TotalFare).toFixed(2) }}  </span>
                    <span class="headline" v-else="item.SelectableFares.TotalFare>0">{{ Number(item.SelectableFares[0].TotalFare).toFixed(2)  }}   </span>
                </v-flex>

                <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                 
                 
                     <v-btn 
                   
                    color="success"
                    @click="openPanel(i, 1, true)"
                    >SEC</v-btn
                  >
                  <!-- <v-btn v-else color="success" @click="openMailDialog()"
                    >SEC</v-btn
                  > -->
                </v-flex>
              </v-layout>

              <v-flex xs12 sm12 md12>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 sm4 md2>
                <v-chip color="green" text-color="white" small>{{
                  item.FlightSegments[0].CabinType
                }}</v-chip>
              </v-flex>

              <!-- AKTARMASIZ TEK YON UCUSLAR -->

              <v-flex xs12 sm4 md4 v-if="FlightType == 'OW'">
                <v-chip
                  color="blue"
                  text-color="white"
                  small
                  v-show="checkDirect(item.FlightSegments)"
                  >{{ $t("Direct") }}</v-chip
                >
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  {{ $t("Transfer-Flight") }} :
                  {{ calculateTimediff(item.FlightSegments, 1) }}</v-chip
                >
              </v-flex>

              <!-- AKTARMALI TEK YON UCUSLAR -->

              <v-flex
                xs12
                sm4
                md4
                v-if="FlightType == 'RT' && item.FlightSegments.length == 2"
              >
                <v-chip
                  color="blue"
                  text-color="white"
                  small
                  v-show="checkDirect(item.FlightSegments)"
                >
                  {{ $t("Direct") }}
                </v-chip>
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  {{ $t("Transfer-Flight") }} :
                  {{ calculateTimediff(item.FlightSegments, 1) }}</v-chip
                >
              </v-flex>

              <!-- AKTARMALI GIDIS DONUS UCUSLARI -->

              <v-flex
                xs12
                sm4
                md4
                v-if="FlightType == 'RT' && item.FlightSegments.length == 6"
              >
                <v-chip
                  color="blue"
                  text-color="white"
                  v-show="checkDirect(item.FlightSegments)"
                  small
                >
                  {{ $t("Direct") }}
                </v-chip>
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  {{ $t("Transfer-Flight") }} :
                  {{ calculateTimediff(item.FlightSegments, 5) }}</v-chip
                >
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  Dönüş aktarma:
                  {{ calculateTimediff(item.FlightSegments, 6) }}</v-chip
                >
              </v-flex>

              <!-- AKTARMALI GIDIS DONUS UCUSLARI -->

              <v-flex
                xs12
                sm4
                md4
                v-if="FlightType == 'RT' && item.FlightSegments.length == 4"
              >
                <v-chip
                  color="blue"
                  text-color="white"
                  v-show="checkDirect(item.FlightSegments)"
                  small
                >
                  {{ $t("Direct") }}</v-chip
                >
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  {{ $t("Transfer-Flight") }} :
                  {{ calculateTimediff(item.FlightSegments, 1) }}</v-chip
                >
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  Dönüş aktarma:
                  {{ calculateTimediff(item.FlightSegments, 2) }}</v-chip
                >
              </v-flex>

              <v-flex xs12 sm4 md2>
                <v-chip color="indigo" text-color="white" small
                  >Branded Fares / {{ item.FlightSegments[0].BookingClass }} /
                  {{ item.FlightSegments[0].ResBookDesigQuantity }}
                </v-chip>
              </v-flex>
              <v-flex xs12 sm4 md2 class="my-auto text-xs-center">
                <v-btn
                  flat
                  small
                  class="my-0"
                  
                  @click="openPanel(i, 2, false)"
                >
                  {{ $t("Show-Details") }}
                </v-btn>
              </v-flex>
              <v-flex xs12 sm4 md2 class="my-auto text-xs-center" v-if="item.SelectableFares==null || item.SelectableFares==[]">
                <v-btn
                  flat
                  small
                  class="my-0"
                 
                  @click="openPanel(i, 3, false)"
                >
                  Diğer Fiyatlar
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </template>

        <v-container
          v-if="cardView || tableView || otherPrices"
          fluid
          grid-list-xl
        >
          <v-layout row wrap>

           
            <v-flex v-if="cardView" >
            
              <v-layout v-if="item.IsSelectableFare==true">
<v-flex md4 v-for="itemflare in item.SelectableFares" :key="itemflare.FareCode">
<v-card class="card-container" :title="getFareTitle(itemflare)" height="100%">
       <v-card-title primary-title style="background-color: #92a2a8;">
        <v-layout justify-center >
            <h5 class="subheading mb-0"> {{ getFareTitle(itemflare) }}  </h5>
        </v-layout>
        </v-card-title>
        <v-card-text style="height:375px">
          <v-layout justify-center style="text-align:center;padding:6px;">
          {{ Number(itemflare.TotalFare).toFixed(2)  }} {{ itemflare.Currency }} 
          
        </v-layout>
        <v-divider></v-divider>
       
       <div v-if="item.FlightSegments[0].MarkettingAirline=='PC'">
        <br>
        <PegasusFareFeatures :fareName="itemflare.FareName" flightType="domestic" />
       </div>
       <div v-else-if="item.FlightSegments[0].MarkettingAirline=='TK'">
        <br>
        <THYFareFeatures :fareName="itemflare.FareName" flightType="domestic" />
       </div>
       <div v-else-if="item.FlightSegments[0].MarkettingAirline=='VF' || item.FlightSegments[0].MarkettingAirline=='IZ'">
        <br>
        <AjetFareFeatures :fareName="itemflare.FareName" flightType="domestic" />
       </div>
       <div v-else-if="itemflare.Penalties!='undefined' && itemflare.Penalties!=null">
         <v-flex md12>
          
          <v-layout justify-center style="text-align:center;padding:6px;" v-if='itemflare.CarryOnBaggageAllowance!=null'>
          {{  itemflare.CarryOnBaggageAllowance.Pieces }} Parça   {{  itemflare.CarryOnBaggageAllowance.Kilos }} kg Kabin Bagaj Hakkı 
        </v-layout>
       </v-flex>
      
      
        <v-flex md12>
          <v-divider></v-divider>
          <v-layout justify-center style="text-align:center;padding:6px;">
         {{  itemflare.CheckedBaggageAllowance.Pieces }} Parça   {{  itemflare.CheckedBaggageAllowance.Kilos }} kg Bagaj Hakkı  
        </v-layout>
       </v-flex>
  <v-flex md12  v-for="penalties in itemflare.Penalties.ChangePenalties">
        
          <v-layout justify-center style="text-align:center;padding:6px;" v-if="penalties.TimeToDeparture!=null" >
           
        
             <span v-if="penalties.TimeToDeparture.TimePeriodCondition=='LESS'">  Uçuş'a {{ penalties.TimeToDeparture.TimeAmount }} Saat veya Daha Az Zaman Var ise <span v-if="penalties.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  penalties.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="penalties.IsChangeable"> Değişiklik Yapılabilir</span><span v-else> Değişiklik Yapılamaz</span> </span><span v-else>  Uçuş'a {{ penalties.TimeToDeparture.TimeAmount }} Saat veya Daha Fazla Zaman Var ise <span v-if="penalties.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  penalties.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="penalties.IsChangeable"> Değişiklik Yapılabilir</span><span v-else> Değişiklik Yapılamaz</span></span>
        </v-layout>
        <v-layout justify-center style="text-align:center;padding:6px;" v-if="penalties.TimeToDeparture==null && penalties.Penalty!=null" >
           <span >{{ penalties.Penalty }}</span>
      </v-layout>
       </v-flex>
        <v-flex md12 v-if="itemflare.Penalties!='undefined' && itemflare.Penalties!='null'" v-for="cancellation in itemflare.Penalties.CancellationPenalties">
         
          <v-layout justify-center style="text-align:center;padding:6px;" v-if="cancellation.TimeToDeparture!=null" >
            <span v-if="cancellation.TimeToDeparture.TimePeriodCondition=='LESS'">  Uçuş'a {{ cancellation.TimeToDeparture.TimeAmount }} Saat veya Daha Az Zaman Var ise <span v-if="cancellation.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  cancellation.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="cancellation.IsRefundable"> İptal Edilebilir</span><span v-else> İptal Edilemez</span> </span><span v-else>  Uçuş'a {{ cancellation.TimeToDeparture.TimeAmount }} Saat veya Daha Fazla Zaman Var ise <span v-if="cancellation.PercentageOrFixedAmount.FixedAmount.Amount>0"> {{  cancellation.PercentageOrFixedAmount.FixedAmount.Amount }} TRY Ceza İle</span><span v-if="cancellation.IsRefundable"> İptal Edilebilir</span><span v-else> İptal Edilemez</span></span>
        </v-layout>
        <v-layout justify-center style="text-align:center;padding:6px;" v-if="cancellation.TimeToDeparture==null && cancellation.Penalty!=null" >
           <span >{{ cancellation.Penalty }}</span>
      </v-layout>
        </v-flex>
          <v-flex md12>
          
        
       </v-flex>
       </div><div v-else></div>
      
        </v-card-text>
      <v-card-actions >
        <v-divider></v-divider>
        <v-btn :id="itemflare.FareCode" color="success"  @click="selectFare(itemflare.FareCode,item)">Seç<v-icon right dark v-if="selectedFareCode === itemflare.FareCode ">check</v-icon></v-btn>
      </v-card-actions>
       
       


</v-card>
</v-flex>

</v-layout>

       
        <v-layout v-if="item.IsSelectableFare==false">
          <v-flex md-12>
     <div class="d-flex justify-end mb-6 text-lg-right">
      
      <v-flex md6 sm6>
          <span class="headline mt-2">Tutar :</span>
        <span class="headline mt-2">{{ Number(item.TotalFare).toFixed(2) }}</span>
 <v-divider></v-divider>
          
      </v-flex>
      <v-flex md1>
  <v-btn
      color="blue-grey"
      class="white--text"
      @click="selectFare('',item)"
    >
      {{$t('Continue')}}
      <v-icon right dark>check</v-icon>
    </v-btn>
      </v-flex>
  
         
     </div>
          </v-flex>
        

          
        </v-layout>
      
       
     

             
            </v-flex>
          </v-layout>
          <v-layout align-start justify-space-between row fill-height>
            <v-flex xs12 sm12 md12 sm4 md4 v-if="tableView">
            
              <v-data-table
                :headers="headersSummary"
                :items="item.FlightSegments"
                class="elevation-1 mb-3"
                hide-actions
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item.OperatingAirline }} {{ '-' }} <span v-if="props.item.DirectionInd==0"> Gidiş </span> <span v-if="props.item.DirectionInd==1"> Dönüş </span>
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.FlightNumber }} -
                    {{ props.item.DepartureAirportCode }} -
                    {{ props.item.ArrivalAirportCode }}
                  </td>
                  <td class="text-xs-left">
                    {{ formatDate(props.item.DepartureDate) }} -
                    {{ props.item.DepartureTime }}
                  </td>
                  <td class="text-xs-left">
                    {{ formatDate(props.item.ArrivalDate) }} -
                    {{ props.item.ArrivalTime }}
                  </td>
                  <td class="text-xs-left">{{ props.item.EquipmentType }}</td>
                  <td class="text-xs-left">
                    {{ props.item.CabinType }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.ResBookDesigQuantity }}
                  </td>
                </template>
              </v-data-table>

<div v-if="1==0">
  <v-data-table 
                :headers="headers"
                class="elevation-1"
                :items="item.SelectableFares"
                hide-actions
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item.PassengerTypeCode }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.BaseFare }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.TotalTax }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.ServiceFee }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.PassengerTypeQuantity }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.BaggageAllowance }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.TotalFare }}
                  </td>
                </template>

                <template v-slot:footer>
                  <td>
                    <strong> {{ $t("Totals") }} </strong>
                  </td>
                  <td>
                    <strong>{{ calculateFooter(1, i) }}</strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(2, i) }} </strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(3, i) }} </strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(4, i) }} </strong>
                  </td>
                  <td>
                    <strong></strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(5, i) }} </strong>
                  </td>
                </template>
              </v-data-table>
</div>
             


            </v-flex>
          </v-layout>
          <v-layout row wrap justify-end>
           
            <v-flex v-if="otherPrices" xs12 sm12 md12 px-5>
             <template>
  <v-layout row wrap>
    <v-flex
      v-for="(itemPrices, i) in otherPricesList"
      :key="i"
      xs12 sm6 md4 lg3
      class="pa-2"
    >
      <v-card class="flight-card" hover>
        <!-- HEADER -->
        <v-card-title class="py-2">
          <v-layout row wrap align-center>
            <v-flex xs12>
              <div class="title font-weight-medium">
                {{ getRouteTitle(itemPrices) }}
              </div>
              <div class="caption grey--text">
                {{ getAirlineTitle(itemPrices) }}
              </div>
            </v-flex>

            <v-flex xs12 class="pt-2">
              <v-layout row wrap align-center>
                <v-chip small color="primary" text-color="white" class="mr-2">
                  {{ getFareName(itemPrices) }}
                </v-chip>

                <v-chip small outline class="mr-2">
                  {{ getCabin(itemPrices) }}
                </v-chip>

                <v-spacer></v-spacer>

                <div class="subtitle-1 font-weight-bold">
                  {{ formatMoney(getTotalFare(itemPrices), getCurrency(itemPrices)) }}
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-title>
<br>
        <v-divider></v-divider>

        <!-- SEGMENTS -->
        <v-card-text class="py-2">
          <v-layout v-if="!getSegments(itemPrices).length" row wrap>
            <v-flex xs12 class="caption grey--text text-xs-center">
              Segment bilgisi yok
            </v-flex>
          </v-layout>

          <v-layout
            v-for="(seg, s) in getSegments(itemPrices)"
            :key="s"
            row
            wrap
            class="mb-2"
          >
            <!-- Departure -->
            <v-flex xs5>
              <div class="headline font-weight-medium">
                {{ seg.DepartureTime || '-' }}
              </div>
              <div class="body-2 font-weight-medium">
                {{ seg.DepartureAirportCode || '-' }}
              </div>
              <div class="caption grey--text">
                {{ seg.DepartureAirportName || '' }}
              </div>
              <div class="caption grey--text">
                {{ seg.DepartureDate || '' }}
              </div>
            </v-flex>

            <!-- Middle -->
            <v-flex xs2 class="text-xs-center">
              <v-icon small class="mt-2">flight_takeoff</v-icon>
              <div class="caption grey--text mt-1">
                {{ formatDuration(seg.JourneyDurationInMinute) || '-' }}
              </div>
              <!-- <div class="caption grey--text">
                {{ seg.MarkettingAirline || seg.OperatingAirline || '-' }}
              </div>
              <div class="caption grey--text">
                {{ seg.FlightNumber || '' }}
              </div> -->
            </v-flex>

            <!-- Arrival -->
            <v-flex xs5 class="text-xs-right">
              <div class="headline font-weight-medium">
                {{ seg.ArrivalTime || '-' }}
              </div>
              <div class="body-2 font-weight-medium">
                {{ seg.ArrivalAirportCode || '-' }}
              </div>
              <div class="caption grey--text">
                {{ seg.ArrivalAirportName || '' }}
              </div>
              <div class="caption grey--text">
                {{ seg.ArrivalDate || '' }}
              </div>
            </v-flex>

            <!-- Detail row -->
            <v-flex xs12 class="pt-2">
              <div class="caption grey--text">
                Sınıf: {{ seg.BookingClass || '-' }} • Kabin: {{ seg.CabinType || '-' }}
                <span v-if="getBaggageText(itemPrices)">
                   {{ getBaggageText(itemPrices) }}
                </span>
              </div>
            </v-flex>

            <v-flex xs12 v-if="s < getSegments(itemPrices).length - 1">
              <v-divider class="my-2"></v-divider>
            </v-flex>
          </v-layout>
          <v-flex xs12 class="pt-2">
  <v-divider class="mb-2"></v-divider>

  <div class="caption grey--text font-weight-medium mb-1">
    Bagaj & Kurallar
  </div>

  <!-- Bagaj satırı -->
  <v-layout row wrap>
    <v-flex xs12 class="caption grey--text">
      <v-icon small class="mr-1">work</v-icon>
      Kabin:
      <span class="font-weight-medium">{{ getCarryOnText(itemPrices) }}</span>

      <span class="mx-2">•</span>

      <v-icon small class="mr-1">luggage</v-icon>
      Check-in:
      <span class="font-weight-medium">{{ getCheckedText(itemPrices) }}</span>
    </v-flex>
  </v-layout>

  <!-- Ceza/Koşul satırı -->
  <v-layout row wrap class="mt-1">
    <v-flex xs12 class="caption grey--text">
      <v-icon small class="mr-1">autorenew</v-icon>
      Değişiklik:
      <span class="font-weight-medium">{{ getChangePenaltyText(itemPrices) }}</span>

      <span class="mx-2">•</span>

      <v-icon small class="mr-1">cancel</v-icon>
      İptal:
      <span class="font-weight-medium">{{ getCancelPenaltyText(itemPrices) }}</span>
    </v-flex>
  </v-layout>
</v-flex>
        </v-card-text>

        <v-divider></v-divider>

        <!-- FOOTER -->
        <v-card-actions>
          <v-layout row wrap align-center>
            <v-flex xs12 class="caption grey--text">
              Vergi: {{ formatMoney(getTotalTax(itemPrices), getCurrency(itemPrices)) }}
              • Taban: {{ formatMoney(getBaseFare(itemPrices), getCurrency(itemPrices)) }}
            </v-flex>

            <v-flex xs12 class="pt-2">
              <v-btn block color="primary" dark @click="setUpSellTicket(itemPrices)">
                Seç
              </v-btn>
            </v-flex>
          </v-layout>
        
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

             
            </v-flex>
          </v-layout>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
    </div>

    
<v-dialog v-model="dialogpickitem" persistent max-width="490">
        <v-card>
          <v-card-title class="headline primary white--text">
            {{fare}} {{ $t('Markup-Added-per-Person') }}
            <v-spacer></v-spacer>
           
          </v-card-title>
          <v-card-text>
            <v-text-field
                 v-if="!isUpSell"
                outline
                 :label="$t('Markup-Added-per-Person')"
                v-model="ticketMarkup"
                @keyup.enter="pickTicket(pickeditem)"
               
              >
              </v-text-field>

              <v-text-field
            
                v-if="isUpSell"
                outline
                :label="$t('Markup-Added-per-Person')"
                v-model="ticketMarkup"
                @keyup.enter="pickTicket(upSellTicket)"
              
              >
              </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
             <v-btn color="primary" flat @click="dialogpickitem = false">{{
              $t("Cancel")
            }}
          
          </v-btn>
         
            <v-btn color="primary" flat @click="pickTicket(upSellTicket)"  v-if="isUpSell">{{
              $t("Continue")
            }}
          <v-icon right>send</v-icon>  
          </v-btn>
           <v-btn color="primary" flat @click="pickTicket(pickeditem)"  v-if="!isUpSell">{{
              $t("Continue")
            }}
          <v-icon right>send</v-icon>  
          </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-layout row justify-center>
      <v-dialog v-model="dialogUserInfo" persistent max-width="490">
        <v-card>
          <v-card-title class="headline primary white--text">
            Arkman - Sem Bilet
            <v-spacer></v-spacer>
            <v-btn
              flat
              icon
              color="primary"
              @click.native="dialogUserInfo = false"
            >
              <v-icon class="white--text">cancel</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-form ref="userInfoForm">
              <v-text-field
                :label="$t('Username')"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="userInfo.userName"
              ></v-text-field>
              <v-text-field
                :label="$t('Telephone')"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="userInfo.userPhone"
              ></v-text-field>
              <v-text-field
                :label="$t('Email_label')"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="userInfo.userMail"
              ></v-text-field>
              <v-text-field
                label="Mesaj"
                v-model="userInfo.Message"
                textarea
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="sendEmail()">{{
              $t("Send")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import logoo from "../../../../../assets/control";
import helpers from "@/components/app/customcomp/helpers.js";
import Airports from "@/components/app/satis/ucak/airports.js";
import axios from "axios";
import auth from "@/api/auth.js";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import PegasusFareFeatures from "./PegasusFareFeatures.vue";
import AjetFareFeatures from "./AjetFareFeatures.vue";
import THYFareFeatures from "./THYFareFeatures.vue";
export default {
  props: {
    ticketList: {
      type: Array,
    },
    FlightType: {
      type: String,
    },
    isActive: {
      type: Boolean,
    },
     isDomesticRT: {
      type: Boolean,
    },
  },
  components: {
    loadingcomp,
    snackbarcomp,
    PegasusFareFeatures,
    AjetFareFeatures,
    THYFareFeatures,
  },
  data() {
    return {
       snackbarkColor: null,
      text1: null,
      snackbar: false,
       cardViewGidis : false,
        tableViewGidis : false,
        otherPricesGidis : false,
      domesticRTpickGidisItem:null,
      domesticRTpickDonusItem:null,
      domesticRTselectedGidisFareCode:'',
      domesticRTselectedDonusFareCode:'',
      dialogpickitem:false,
      pickeditem:null,
      selectedFareCode:'',
      loadingvmodel: false,
      otherPricesList: [],
      otherPrices: false,
      dialogAds: false,
      headersSummary: [
        {
          text: this.$t("Airline"),
          sortable: false,
        },
        {
          text: this.$t("Flight"),
          sortable: false,
        },
        {
          text: this.$t("Departure-TWO"),
          sortable: false,
        },
        {
          text: this.$t("Arrival"),
          sortable: false,
        },
        {
          text: this.$t("Plane-Type"),
          sortable: false,
        },
        {
          text: this.$t("Cabin"),
          sortable: false,
        },
        {
          text: this.$t("Seat"),
          sortable: false,
        },
      ],
      headers: Airports.headersSummary(),
      ticketMarkup: 0,
      openedPanel: null,
      cardView: false,
      tableView: false,
      allocated: Airports.allocateParams(),
      allocateItems: Airports.allocateItems(),
      userInfo: {
        userName: null,
        userPhone: null,
        userMail: null,
        Message: null,
      },
      dialogUserInfo: false,
      upSellTicket: {},
      isUpSell: false,
    };
  },
  methods: {
    async getProvidersTurna() {
  try {
    var bookingParams = JSON.parse(
      window.localStorage.getItem("bookingParams")
    );

    var params = {
      SessionHeader: {
        SessionId: bookingParams.SessionId,
        SessionToken: bookingParams.SessionToken
      }
    };

    const response = await this.$http.post(
      auth.BOOKING_API_URL + "Agency/GetCredential",
      params,
      {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      }
    );

    const rsp = response.body.Credentials;

    const turnaProvider = rsp.find(x =>
      x.ProviderType === "Air" &&
      x.Provider === "Turna" &&
      x.OfficeId &&
      x.OfficeId !== ""
    );

    return !!turnaProvider; 

  } catch (error) {
    this.text1 = "GetCredential - Service Unavailable";
    this.loadingvmodel = false;
    this.snackbar = true;
    return false;
  }
},
    //diger fiyatlar metodları
    getSelectableFare(itemPrices) {
  return (itemPrices && itemPrices.SelectableFares && itemPrices.SelectableFares.length)
    ? itemPrices.SelectableFares[0]
    : null;
},

// Kabin bagajı text
getCarryOnText(itemPrices) {
  const sf = this.getSelectableFare(itemPrices);
  const c = sf && sf.CarryOnBaggageAllowance;
  if (!c) return "Bilgi yok";

  const parts = [];
  if (typeof c.Pieces === "number") parts.push(c.Pieces + " parça");
  if (typeof c.Kilos === "number") parts.push(c.Kilos + " kg");

  return parts.length ? parts.join(" • ") : "Bilgi yok";
},

// Check-in bagajı text
getCheckedText(itemPrices) {
  const sf = this.getSelectableFare(itemPrices);
  const ch = sf && sf.CheckedBaggageAllowance;
  if (!ch) return "Bilgi yok";

  const parts = [];
  if (typeof ch.Pieces === "number") parts.push(ch.Pieces + " parça");
  if (typeof ch.Kilos === "number") parts.push(ch.Kilos + " kg");

  return parts.length ? parts.join(" • ") : "Bilgi yok";
},

getChangePenaltyText(itemPrices) {
  const sf = this.getSelectableFare(itemPrices);
  const list = sf && sf.Penalties && Array.isArray(sf.Penalties.ChangePenalties)
    ? sf.Penalties.ChangePenalties
    : null;

  // JSON'unda boş dizi geliyor -> en doğru mesaj:
  if (list && list.length === 0) return "Bilgi yok";
  if (!list) return "Bilgi yok";

  // Eğer ileride dolu gelirse özetle
  return this.formatPenaltyList(list);
},

getCancelPenaltyText(itemPrices) {
  const sf = this.getSelectableFare(itemPrices);
  const list = sf && sf.Penalties && Array.isArray(sf.Penalties.CancellationPenalties)
    ? sf.Penalties.CancellationPenalties
    : null;

  if (list && list.length === 0) return "Bilgi yok";
  if (!list) return "Bilgi yok";

  return this.formatPenaltyList(list);
},

// Penalty listeleri farklı şemalarda gelebilir; birkaç olası alanı toparlayıp tek satır yapar.
formatPenaltyList(list) {
  if (!list || !list.length) return "Bilgi yok";

  var result = [];

  for (var i = 0; i < list.length && i < 2; i++) {
    var p = list[i];
    if (!p) continue;

    var amount =
      p.Amount != null
        ? p.Amount
        : (p.PenaltyAmount != null
            ? p.PenaltyAmount
            : (p.Price != null ? p.Price : null));

    var currency =
      p.Currency != null
        ? p.Currency
        : (p.PenaltyCurrency != null ? p.PenaltyCurrency : "");

    var desc =
      p.Description != null
        ? p.Description
        : (p.Text != null
            ? p.Text
            : (p.Rule != null ? p.Rule : null));

    if (desc) {
      result.push(desc);
    } else if (amount != null) {
      result.push(
        Number(amount).toLocaleString("tr-TR") +
        (currency ? " " + currency : "")
      );
    } else {
      result.push("Kural var");
    }
  }

  return result.length ? result.join(" / ") : "Bilgi yok";
},
 getSegments(itemPrices) {
      return (itemPrices && itemPrices.FlightSegments && itemPrices.FlightSegments.length)
        ? itemPrices.FlightSegments
        : [];
    },

    getTotalFare(itemPrices) {
      return itemPrices.TotalFare || (itemPrices.PricingInfo && itemPrices.PricingInfo.TotalFare) || 0;
    },

    getBaseFare(itemPrices) {
      return (itemPrices.PricingInfo && itemPrices.PricingInfo.BaseFare) || 0;
    },

    getTotalTax(itemPrices) {
      return (itemPrices.PricingInfo && itemPrices.PricingInfo.TotalTax) || 0;
    },

    getCurrency(itemPrices) {
      return (
        (itemPrices.PricingInfo && itemPrices.PricingInfo.Currency) ||
        (itemPrices.SelectableFares && itemPrices.SelectableFares[0] && itemPrices.SelectableFares[0].Currency) ||
        itemPrices.Currency ||
        "TRY"
      );
    },

    getFareName(itemPrices) {
      const fb = itemPrices.PricingInfo && itemPrices.PricingInfo.FareBreakdowns;
      return (fb && fb[0] && fb[0].FareName) ||
             (itemPrices.SelectableFares && itemPrices.SelectableFares[0] && itemPrices.SelectableFares[0].FareName) ||
             "-";
    },

    getCabin(itemPrices) {
      const segs = this.getSegments(itemPrices);
      return (segs[0] && segs[0].CabinType) || "-";
    },

    getRouteTitle(itemPrices) {
      const segs = this.getSegments(itemPrices);
      if (!segs.length) return "-";
      const first = segs[0];
      const last = segs[segs.length - 1];
      return (first.DepartureAirportCode || "-") + " → " + (last.ArrivalAirportCode || "-");
    },

    getAirlineTitle(itemPrices) {
      const segs = this.getSegments(itemPrices);
      if (!segs.length) return "";
      const a = segs[0].MarkettingAirlineName || segs[0].OperatingAirlineName || "";
      const no = segs[0].FlightNumber || "";
      return [a, no].filter(Boolean).join(" • ");
    },

    getBaggageText(itemPrices) {
      const fb = itemPrices.PricingInfo && itemPrices.PricingInfo.FareBreakdowns;
      const allowance = (fb && fb[0] && fb[0].BaggageAllowance) ? fb[0].BaggageAllowance : null;
      const bags = fb && fb[0] && fb[0].IncludedCheckedBags && fb[0].IncludedCheckedBags[0];

      if (bags && typeof bags.Quantity === "number") {
        if (bags.Quantity === 0) return "";
        if (bags.Quantity > 0) return bags.Quantity + " parça";
      }
      return allowance || "";
    },
formatDuration(minutes) {
  if (minutes == null || isNaN(minutes)) return "-";

  var total = parseInt(minutes, 10);
  if (total <= 0) return "-";

  var hours = Math.floor(total / 60);
  var mins = total % 60;

  
  if (hours === 0) {
    return mins + " dakika";
  }

  
  if (mins === 0) {
    return hours + " saat";
  }

  return hours + " saat " + mins + " dakika";
},
    formatMoney(amount, currency) {
      const n = Number(amount || 0);
      return n.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + currency;
    },
    //diger fiyatlar metod sonu

















    getGidisler(ticketList){

if (this.domesticRTpickGidisItem==null){
  const direction0Tickets = ticketList.filter(ticket =>
  ticket.FlightSegments.some(segment => segment.DirectionInd === 0)
);
   return direction0Tickets;
}else{
   const direction0Tickets = [];
   direction0Tickets.push(this.domesticRTpickGidisItem);

   return direction0Tickets;
}

    
   
  
    },
        getDonusler(ticketList){
if (this.domesticRTpickDonusItem==null){
  const direction1Tickets = ticketList.filter(ticket =>
  ticket.FlightSegments.some(segment => segment.DirectionInd === 1)
);
   return direction1Tickets;
}else{
   const direction1Tickets = [];
   direction1Tickets.push(this.domesticRTpickDonusItem);

   return direction1Tickets;
}
    },
    fareNotes(itemflare) {
  // Zaman/boolean içermeyen serbest metin avantajları topla (örn. "Sandviç ikramı")
  var notes = [];
  var ch = (itemflare.Penalties && itemflare.Penalties.ChangePenalties) || [];
  var cx = (itemflare.Penalties && itemflare.Penalties.CancellationPenalties) || [];

  function onlyNote(p) {
    var hasRule = !!(p.TimeToDeparture || p.IsChangeable === true || p.IsChangeable === false
      || p.IsRefundable === true || p.IsRefundable === false
      || (((p.PercentageOrFixedAmount || {}).FixedAmount || {}).Amount != null));
    return !hasRule && !!p.Penalty;
  }

  ch.forEach(function(p){ if (onlyNote(p)) notes.push(p.Penalty); });
  cx.forEach(function(p){ if (onlyNote(p)) notes.push(p.Penalty); });

  // Tekrarlayan metinleri temizle
  var seen = {};
  return notes.filter(function(n){
    if (seen[n]) return false;
    seen[n] = true;
    return true;
  });
},
  kiloText(allow) {
  if (!allow) return '';
  // JSON bazen KilosString ("8 kg") verir; yoksa Kilos sayısını yaz.
  return allow.KilosString || (allow.Kilos != null ? (allow.Kilos + ' kg') : '');
},
clearGidis(){
  this.domesticRTpickGidisItem=null;
  this.domesticRTselectedGidisFareCode="";
},
clearDonus(){
  this.domesticRTpickDonusItem=null;
     this.domesticRTselectedDonusFareCode="";
},
selectDomesticRTGidisFare(fare,selecteditem){
    this.cardViewGidis=false;
          this.tableViewGidis = false;
          this.isUpSell = false;
          this.otherPricesGidis = false;
     this.domesticRTpickGidisItem=selecteditem;
     this.domesticRTselectedGidisFareCode=fare;
     if (this.domesticRTpickDonusItem!=null){
       this.dialogpickitem=true;
     }
},
selectDomesticRTDonusFare(fare,selecteditem){
  
   this.cardView=false;
          this.tableView = false;
          this.isUpSell = false;
          this.otherPrices = false;
     this.domesticRTpickDonusItem=selecteditem;
     this.domesticRTselectedDonusFareCode=fare;
     if (this.domesticRTpickGidisItem!=null){
       this.dialogpickitem=true;
     }
},
    selectFare(fare,selecteditem)
    {
      
     this.pickeditem=selecteditem;
     this.selectedFareCode=fare;
     this.dialogpickitem=true;
      
    },
    setUpSellTicket(ticket) {
      this.isUpSell = true;
      this.upSellTicket = ticket;
      this.cardView = true;
      this.dialogpickitem=true;
    },
    openInfoDialog() {
      this.dialogAds = false;
      this.dialogUserInfo = true;
      var userInfo = JSON.parse(
        window.localStorage.getItem("WebUserManageLoad")
      );
      this.userInfo.userPhone = userInfo.UserInfo.GSM;
      this.userInfo.userName = userInfo.UserInfo.AdSoyad;
      this.userInfo.userMail = userInfo.UserInfo.Email;
    },
    sendEmail() {
      if (this.$refs.userInfoForm.validate()) {
        let formData = new FormData();
        var mailText =
          "Kullanici Adi = " +
          this.userInfo.userName +
          " | Telefon = " +
          this.userInfo.userPhone +
          " | Mail =  " +
          this.userInfo.userMail +
          " | Mesaj = " +
          this.userInfo.Message +
          " ";

        formData.append("Konu", "Sem Bilet Arkman Entegrasyon Talebi");
        formData.append("to", "demirarkman@arkman.com.tr");
        formData.append("formattedMessage", mailText);
        formData.append("mailType", "0");
        axios.defaults.baseURL = auth.API_URL;
        axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
        axios
          .post(auth.API_URL + "api/Helpers/SendEmail", formData, {
            headers: {},
          })
          .then((response) => {
            if (response.data == true) {
              this.dialogUserInfo = false;
            }
          })
          .catch(function () {});
      }
    },
    openMailDialog() {
      this.dialogAds = false;
    },
    moneyformat(m) {
      if (m != 0) {
        return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      } else {
        return 0;
      }
    },
    checkTransfer(val) {
   
      if (!val || val.length === 0) return false;
      if (this.FlightType!='RT' && val.length>1) return true;
      
      let outboundCount = 0;  // DirectionInd = 0 (Gidiş)
      let inboundCount = 0;   // DirectionInd = 1 (Dönüş)

      val.forEach((segment) => {
        if (segment.DirectionInd === 0 || segment.DirectionInd === '0') {
          outboundCount++;
        } else if (segment.DirectionInd === 1 || segment.DirectionInd === '1') {
          inboundCount++;
        }
      });
      

     
      if (this.FlightType === 'RT') {
        return outboundCount >= 2 || inboundCount >= 2;
      }

      // OW (One Way) uçuş için: 2+ segment varsa aktarmalı
      return val.length >= 2;
    },
    checkDirect(val) {
      if (!val || val.length === 0) return false;

      if (val.length==1) return true;
      
      let outboundCount = 0;  // DirectionInd = 0 (Gidiş)
      let inboundCount = 0;   // DirectionInd = 1 (Dönüş)

      val.forEach((segment) => {
        if (segment.DirectionInd === 0 || segment.DirectionInd === '0') {
          outboundCount++;
        } else if (segment.DirectionInd === 1 || segment.DirectionInd === '1') {
          inboundCount++;
        }
      });

      // RT uçuş için: Her iki yön de 1 segment ise direkt
      if (this.FlightType === 'RT') {
        return outboundCount === 1 && inboundCount === 1;
      }

      // OW (One Way) uçuş için: 1 segment ise direkt
      return val.length === 1;
    },
    calculateFooter(type, ticketIndex) {
      // type 1 : BaseFare , 2: TotalTax , 3: ServiceFee , 4 : PassengerTypeQuantity , 5:TotalFare
      switch (type) {
        case 1:
          var _totalBaseFare = 0;
          this.ticketList[ticketIndex].PricingInfo.FareBreakdowns.forEach(
            (element) => {
              _totalBaseFare = _totalBaseFare + element.BaseFare;
            }
          );
          return _totalBaseFare;
        case 2:
          var _totalTax = 0;
          this.ticketList[ticketIndex].PricingInfo.FareBreakdowns.forEach(
            (element) => {
              _totalTax = _totalTax + element.TotalTax;
            }
          );
          return _totalTax;
        case 3:
          var _totalServiceFee = 0;
          this.ticketList[ticketIndex].PricingInfo.FareBreakdowns.forEach(
            (element) => {
              _totalServiceFee = _totalServiceFee + element.ServiceFee;
            }
          );
          return _totalServiceFee;
        case 4:
          var _totalPassengerTypeQuantity = 0;
          this.ticketList[ticketIndex].PricingInfo.FareBreakdowns.forEach(
            (element) => {
              _totalPassengerTypeQuantity =
                _totalPassengerTypeQuantity + element.PassengerTypeQuantity;
            }
          );
          return _totalPassengerTypeQuantity;
        case 5:
          var _totalTotalFare = 0;
          this.ticketList[ticketIndex].PricingInfo.FareBreakdowns.forEach(
            (element) => {
              _totalTotalFare = _totalTotalFare + element.TotalFare;
            }
          );
          return _totalTotalFare;

        default:
          break;
      }
    },
    getFareTitle(fare){
    
      if (fare.FareName!=null && fare.FareName!=''){
        return fare.FareName;
      }else{
        return fare.FareCode;
      }
    },
    formatDate(date) {
      var dateArray = date.split(" ");
      return dateArray[0];
    },
    ConvertTimeUnit(unit) {
      return unit == "HOUR" ? "saat" : unit;
    },
    ConvertTimePeriodCondition(period) {
      switch (period) {
        case "LESS":
          return "az";
        case "MORE":
          return "fazla";
        default:
          return period;
      }
    },
    calculateTimediff(val, type) {
      var start = null;
      var end = null;

      switch (val.length) {
        case 2:
          start = val[0].ArrivalDateTime;
          end = val[val.length - 1].DepartureDateTime;
          break;
        case 3:
          start = val[1].ArrivalDateTime;
          end = val[val.length - 1].DepartureDateTime;
          break;
        case 4:
          if (type == 1) {
            start = val[0].ArrivalDateTime;
            end = val[1].DepartureDateTime;
          } else {
            start = val[2].ArrivalDateTime;
            end = val[3].DepartureDateTime;
          }

          break;
        case 6:
          if (type == 5) {
            start = val[0].ArrivalDateTime;
            end = val[2].DepartureDateTime;
          } else {
            start = val[3].ArrivalDateTime;
            end = val[5].DepartureDateTime;
          }
          break;
        default:
          break;
      }

      let startDate = new Date(start);
      let endDate = new Date(end);
      let hours = parseInt(
        (Math.abs(endDate - startDate) / (1000 * 60 * 60)) % 24
      );
      let minutes = parseInt(
        (Math.abs(endDate.getTime() - startDate.getTime()) / (1000 * 60)) % 60
      );

      // If using time pickers with 24 hours format, add the below line get exact hours
      if (hours < 0) {
        hours = hours + 24;
      }
       if (hours == 0) {
          return minutes + " dakika";
        } else if (minutes == 0) {
          return hours + " saat ";
        } else {
          return hours + " sa " + minutes + " dk";
        }
     
    },
    calculateHourAndMinute(value) {
      var hours = value / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      if (rhours == 0) {
        return rminutes + " dakika";
      } else if (rminutes == 0) {
        return rhours + " saat ";
      } else {
        return rhours + " sa " + rminutes + " dk";
      }
    },
    getImgUrl(img) {
      return logoo.logoControl(img);
    },
    getOtherPrices(index) {
     
      this.loadingvmodel = true;
      this.allocated = Airports.allocateParams();

      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      var ticket = this.ticketList[index];
     

      this.allocated.SessionHeader.SessionId = bookingParams.SessionId;
      this.allocated.SessionHeader.SessionToken = bookingParams.SessionToken;
      if (ticket.FlightSegments.length > 1) {
        let allocateFirstParams = {
          ProductId: ticket.FlightSegments[0].ProductId,
          FareCode: ticket.FlightSegments[0].FareCode,
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateFirstParams);

        let allocateLastParams = {
          ProductId:
            ticket.FlightSegments[ticket.FlightSegments.length - 1].ProductId,
          FareCode:  ticket.FlightSegments[ticket.FlightSegments.length - 1].FareCode,
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateLastParams);
      } else {
       
        this.allocateItems.ProductId = ticket.Id;
        this.allocateItems.FareCode ='PCofferitem11';
        this.allocateItems.MarkupFare = this.ticketMarkup;
//  ticket.PricingInfo.FareReferenceId
        this.allocated.AllocateItems.push(this.allocateItems);
        
      }

      this.$http.post(auth.BOOKING_API_URL + "Air/Upsell", this.allocated).then(
        (response) => {
          
          if (!response.body.HasError) {
            this.otherPricesList = response.body.OriginDestinationOptions;
                        this.loadingvmodel = false;

          } else {
            this.otherPricesList=[];
            this.text1 = response.body.ServiceError.ErrorMessages[0];
            this.snackbar = true;
            this.loadingvmodel = false;
            this.snackbarkColor="warning";
          }
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable-Air/Allocate";
            this.snackbar = true;
            this.loadingvmodel = false;
          } else {
            this.text1 = "Service Unavailable-Air/Allocate";
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        }
      );
      window.localStorage.setItem(
        "allocateParams",
        JSON.stringify(this.allocated)
      );
    },
 async pickTicket(ticket) {

  var isTurna =
    ticket &&
    ticket.FlightSegments &&
    ticket.FlightSegments.length > 0 &&
    ticket.FlightSegments[0] &&
    ticket.FlightSegments[0].Provider === "Turna";

  if (isTurna) {
    const hasTurna = await this.getProvidersTurna();

    if (!hasTurna) {
      this.text1 = "Bilet Kesim ve Rezervasyon İşlemi İçin Turna Acente Kodu Belirtilmeli";
      this.snackbar = true;
      return;
    }
  }
     this.allocated = Airports.allocateParams();

      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      this.allocated.SessionHeader.SessionId = bookingParams.SessionId;
      this.allocated.SessionHeader.SessionToken = bookingParams.SessionToken;

     if (this.isDomesticRT){
        if (this.domesticRTpickGidisItem.FlightSegments.length>1){
           let allocateFirstParams = {
          ProductId: this.domesticRTpickGidisItem.FlightSegments[0].ProductId,
          FareCode: this.domesticRTpickGidisItem.PricingInfo.FareReferenceId,
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateFirstParams);

         let allocateLastParams = {
          ProductId:
            this.domesticRTpickGidisItem.FlightSegments[this.domesticRTpickGidisItem.FlightSegments.length - 1].ProductId,
          FareCode: this.domesticRTpickGidisItem.PricingInfo.FareReferenceId,
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateLastParams);

        }else{
            this.allocateItems.ProductId = this.domesticRTpickGidisItem.Id;
        this.allocateItems.FareCode = this.domesticRTselectedGidisFareCode;//ticket.pricinginfo.FareReferenceId;
        this.allocateItems.MarkupFare = this.ticketMarkup;

        this.allocated.AllocateItems.push(this.allocateItems);
        }

  if (this.domesticRTpickDonusItem.FlightSegments.length>1){
           let allocateFirstParams = {
          ProductId: this.domesticRTpickDonusItem.FlightSegments[0].ProductId,
          FareCode: this.domesticRTpickDonusItem.PricingInfo.FareReferenceId,
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateFirstParams);

         let allocateLastParams = {
          ProductId:
            this.domesticRTpickDonusItem.FlightSegments[this.domesticRTpickDonusItem.FlightSegments.length - 1].ProductId,
          FareCode: this.domesticRTpickDonusItem.PricingInfo.FareReferenceId,
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateLastParams);

        }else{
            let allocateLastParamsRT = {
          ProductId:
            this.domesticRTpickDonusItem.Id,
          FareCode: this.domesticRTselectedDonusFareCode,
          MarkupFare:this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateLastParamsRT);
        //     this.allocateItems.ProductId = this.domesticRTpickDonusItem.Id;
        // this.allocateItems.FareCode = this.domesticRTselectedDonusFareCode;//ticket.pricinginfo.FareReferenceId;
        // this.allocateItems.MarkupFare = this.ticketMarkup;

        // this.allocated.AllocateItems.push(this.allocateItems);
        }


     }
     else{

 if (ticket.FlightSegments.length > 1) {
 
  var reffare=ticket.PricingInfo.FareReferenceId;
  if (ticket.PricingInfo.FareReferenceId=='undefined' ||  !ticket.PricingInfo.FareReferenceId || ticket.PricingInfo.FareReferenceId==null){
reffare=ticket.PricingInfo.FareReference;
  }
  //  FareCode: reffare,
        let allocateFirstParams = {
          ProductId: ticket.FlightSegments[0].ProductId,
          
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateFirstParams);
       if (this.FlightType != 'RT'){
 let allocateLastParams = {
          ProductId:
            ticket.FlightSegments[ticket.FlightSegments.length - 1].ProductId,
          FareCode: reffare,
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateLastParams);
       }
       
      } else {
        
        this.allocateItems.ProductId = ticket.Id;
        this.allocateItems.FareCode = this.selectedFareCode;//ticket.pricinginfo.FareReferenceId;
        this.allocateItems.MarkupFare = this.ticketMarkup;

        this.allocated.AllocateItems.push(this.allocateItems);
      }
     }
     
     
      
     

     
      
      window.localStorage.setItem("flightType", this.FlightType);
      
      window.localStorage.setItem(
        "allocateParams",
        JSON.stringify(this.allocated)
      );

      var url = "#/satis/ucus/islem/id?islem=new";
      window.open(url, "_self");
      
    },
    openPanelProccess(type, index) {
         this.cardView = false;
         this.tableView = false;
         this.otherPrices = false;
      switch (parseInt(type)) {
        case 1:
       
          this.cardView ? (this.cardView = false) : (this.cardView = true);
          this.tableView = false;
          this.isUpSell = false;
          this.otherPrices = false;
          this.ticketMarkup = 0;
          break;
        case 2:
       
          this.tableView ? (this.tableView = false) : (this.tableView = true);
          this.otherPrices = false;
          this.cardView = false;
          break;
        case 3:
       
          if (this.otherPrices) {
            this.otherPrices = false;
          } else {
            this.otherPrices = true;
            this.getOtherPrices(index);
          }
          this.tableView = false;
          this.cardView = false;
          break;
      }
    },
      openPanelProccessGidis(type, index) {
         this.cardViewGidis = false;
         this.tableViewGidis = false;
         this.otherPricesGidis = false;
      switch (parseInt(type)) {
        case 1:
       
          this.cardViewGidis ? (this.cardViewGidis = false) : (this.cardViewGidis = true);
          this.tableViewGidis = false;
          this.isUpSell = false;
          this.otherPricesGidis = false;
          this.ticketMarkup = 0;
          break;
        case 2:
       
          this.tableViewGidis ? (this.tableViewGidis = false) : (this.tableViewGidis = true);
          this.otherPricesGidis = false;
          this.cardViewGidis = false;
          break;
        case 3:
       
          if (this.otherPricesGidis) {
            this.otherPricesGidis = false;
          } else {
            this.otherPricesGidis = true;
            this.getOtherPrices(index);
          }
          this.tableViewGidis = false;
          this.cardViewGidis = false;
          break;
      }
    },
      openPanelGidis(index, type, value) {
      //type 1: card view 2: detail view 3:other prices

      if (this.openedPanel == index) {
        this.openPanelProccessGidis(type, index);
      } else {
        this.openPanelProccessGidis(type, index);
        this.openedPanel = index;
      }
    },
    openPanel(index, type, value) {
      //type 1: card view 2: detail view 3:other prices

      if (this.openedPanel == index) {
        this.openPanelProccess(type, index);
      } else {
        this.openPanelProccess(type, index);
        this.openedPanel = index;
      }
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
};
</script>

<style scoped>
.openCardListTile {
  height: auto;
  white-space: normal;
  overflow: visible;
}
.provider-span{
   text-align: center;
   padding-left: 12px;
   font-style: italic;
   color:rgb(114, 95, 95);
}
</style>